import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ShieldCheckIcon } from 'lucide-react';
const points = ['Explore the six volumes', 'Open the bonuses', 'Use the material to prepare one of your upcoming swimming lessons'];
export function Guarantee() {
  return <section className="py-20 px-4 bg-ivory" data-id="element-133" data-mp="1x4l75qj2te28">
      <div className="max-w-4xl mx-auto" data-id="element-134" data-mp="1x5mscntt3gxo">
        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-white border-2 border-gold/60 rounded-3xl p-8 md:p-12 text-center" data-id="element-135" data-mp="19eqw9eibhzkm">
          <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-navy text-white mb-8" data-id="element-136" data-mp="1edbwhdxkkj92">
            <ShieldCheckIcon size={48} data-id="element-137" data-mp="qn7ufb014rk6" />
          </div>
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6 text-navy" data-id="element-138" data-mp="lp6bqr6imu98">
            7-Day Money-Back Guarantee
          </h2>
          <div className="space-y-6 text-lg text-graphite max-w-2xl mx-auto" data-id="element-139" data-mp="p0b55p9y4ycs">
            <p data-id="element-140" data-mp="tyco8a7dgxo9">Try the complete Swim Instructor Ready 6-in-1 system.</p>
            <ul className="space-y-2 text-left inline-block" data-id="element-141" data-mp="tw9q12w2fy8g">
              {points.map(point => <li key={point} className="flex items-start gap-3 text-base" data-id="element-142" data-mp="yrp49vxzjw5e">
                  <CheckIcon size={18} className="text-aqua-dark shrink-0 mt-1" data-id="element-143" data-mp="12q4v6ax6too3" />
                  <span data-id="element-144" data-mp="628df2q0knba">{point}</span>
                </li>)}
            </ul>
            <p className="font-medium text-navy" data-id="element-145" data-mp="b0jnnek80zu1">
              If you find that the material is not clear, practical, or useful for your
              teaching needs, contact us within 7 days of your purchase.
            </p>
            <p className="text-navy font-bold text-xl" data-id="element-146" data-mp="k1q4joqs8cnt">
              We will refund 100% of your purchase. No complicated process.
            </p>
            <p className="text-sm text-graphite" data-id="element-147" data-mp="1vf2caapnxff9">Your purchase is protected.</p>
          </div>
        </motion.div>
      </div>
    </section>;
}